import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const VILLA_IMG =
    "https://images.pexels.com/photos/8134745/pexels-photo-8134745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const REVIEWS = [
    {
        name: "Isabelle M.",
        place: "Condo — Plateau Mont-Royal",
        stat: "+42 %",
        statLabel: "de revenus la 1ʳᵉ année",
        text: "Je n'ai plus touché à quoi que ce soit depuis dix-huit mois. Les photos ont transformé mon annonce, et la tarification dynamique a fait le reste.",
    },
    {
        name: "Karim & Sonia B.",
        place: "Chalet — Mont-Tremblant",
        stat: "4,97/5",
        statLabel: "sur 180 séjours",
        text: "Le ménage est digne d'un hôtel. Nos voyageurs le mentionnent dans presque chaque commentaire — et nous, nous profitons du chalet quand nous voulons.",
    },
    {
        name: "Hélène D.",
        place: "4 ½ — Ville de Québec",
        stat: "0 h",
        statLabel: "passée à gérer le logement",
        text: "Clés, ménage, voyageurs, petites réparations… tout est pris en charge. Je reçois simplement mon virement et un bilan chaque mois.",
    },
];

export default function Testimonials() {
    return (
        <section id="avis" data-testid="testimonials-section" className="relative overflow-hidden py-28">
            <div className="absolute inset-0">
                <img src={VILLA_IMG} alt="" className="h-full w-full object-cover opacity-10" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#FAF8F5] via-[#FAF8F5]/80 to-[#FAF8F5]" />
            </div>
            <div className="relative mx-auto max-w-7xl px-6">
                <Reveal>
                    <p className="eyebrow mb-6 flex items-center gap-3">
                        <span className="inline-block h-px w-10 bg-[#8A7563]" />
                        Ils nous confient leurs clés
                    </p>
                    <h2 className="font-display max-w-2xl text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
                        Des propriétaires sereins, <span className="italic text-[#8A7563]">des revenus qui grandissent.</span>
                    </h2>
                </Reveal>

                <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
                    {REVIEWS.map((r, i) => (
                        <Reveal key={r.name} delay={i * 0.1}>
                            <figure
                                data-testid={`testimonial-card-${i + 1}`}
                                className="flex h-full flex-col rounded-2xl border border-[#2B2622]/10 bg-[#FFFFFF]/80 p-8 backdrop-blur-xl transition-all duration-500 hover:-translate-y-1.5 hover:border-[#8A7563]/35"
                            >
                                <Quote size={22} className="text-[#8A7563]/50" />
                                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-[#5A4F44]">« {r.text} »</blockquote>
                                <div className="mt-7 flex items-end justify-between border-t border-[#2B2622]/10 pt-6">
                                    <div>
                                        <figcaption className="text-sm font-semibold">{r.name}</figcaption>
                                        <p className="mt-0.5 text-xs text-[#8A7F72]">{r.place}</p>
                                        <div className="mt-2 flex gap-0.5">
                                            {Array.from({ length: 5 }).map((_, s) => (
                                                <Star key={s} size={11} className="fill-[#8A7563] text-[#8A7563]" />
                                            ))}
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <p className="font-display text-3xl font-semibold text-[#8A7563]">{r.stat}</p>
                                        <p className="mt-1 max-w-[110px] text-[10px] uppercase tracking-[0.15em] text-[#8A7F72]">{r.statLabel}</p>
                                    </div>
                                </div>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
